if (!customElements.get('product-lightbox')) {
  customElements.define(
    'product-lightbox',
    class Lightbox extends ModalDialog {
      constructor() {
        super();
        this.mainEmblaCarousel = null;
        this.HIDE_MODAL_CLOSE_TIMEOUT = 300;
        this.lightboxEmblaCarousel = this.querySelector('embla-carousel');
      }

      connectedCallback() {
        this.lightboxEmblaCarousel.removeAttribute('skip-init');
        super.connectedCallback();

        this.lightboxEmblaCarousel?.emblaApi?.on('scroll', (emblaApi) => {
          this.mainEmblaCarousel?.emblaApi.scrollTo(emblaApi.selectedScrollSnap());
        });
      }

      hide() {
        this.lightboxEmblaCarousel.querySelectorAll('video[autoplay]').forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

        if (this.mainEmblaCarousel) {
          this.mainEmblaCarousel.querySelectorAll('video[autoplay]').forEach((video) => {
            setTimeout(() => {
              video.play();
            }, 100);
          });
        }

        super.hide();
      }

      show(opener, event) {
        super.show(opener);

        this.lightboxEmblaCarousel.querySelectorAll('video[autoplay]').forEach((video) => {
          video.play();
        });
        this.mainEmblaCarousel = event.target.closest('embla-carousel') || null;

        if (event.target.dataset.slideIndex !== undefined) {
          this.lightboxEmblaCarousel?.emblaApi.scrollTo(Number(event.target.dataset.slideIndex));
        } else {
          if (event.target.closest('[data-slide-index]')) {
            this.lightboxEmblaCarousel?.emblaApi.scrollTo(
              Number(event.target.closest('[data-slide-index]').dataset.slideIndex),
            );
          }
        }
      }
    },
  );
}
